var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20.4,
    fill: "url(#pin_svg__a)",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M34.8 22.263c0 7.068-8.127 13.113-10.282 14.592a.908.908 0 0 1-1.038 0C21.326 35.376 13.2 29.33 13.2 22.263 13.2 16.264 18.034 11.4 24 11.4c5.963 0 10.8 4.864 10.8 10.863Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M28.723 22.263c0 2.625-2.115 4.753-4.725 4.753-2.61 0-4.725-2.128-4.725-4.753s2.116-4.753 4.725-4.753c2.61 0 4.725 2.128 4.725 4.753Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__a",
    x1: 44.898,
    x2: 3.578,
    y1: 23.369,
    y2: 23.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgPin;